<template>
    <div class="container frames-video">
        <div class="row ">
            <div class="col-md-4 text-left input-find">
                <div class="search-box" v-if="$store.getters.getIsplaylist">
                    <input  v-model="searchLOString" type="text" class="form-control" :placeholder="$t('contentViewer.placeholder.searchContentHere')" >
                    <span class="input-icon"><i class="mdi mdi-magnify"></i></span>
                </div>
              <div class="frame-holder" v-bar>                        
                <div class="vbar-holder" v-if="$store.getters.getSearchPlaylistLO(searchLOString) !== null && $store.getters.getSearchPlaylistLO(searchLOString).length > 0">
                  <div class="cards" v-for="(content,i) in $store.getters.getSearchPlaylistLO(searchLOString)" :key="i" >
                     <!-- <div v-for="content in $store.getters.getCurrentContentViewerPlaylist" :key="content.contentID" > -->
                    <div :class="$store.getters.getcurrentPlayingContent.contentId === content.contentId ? 'card card-active' : 'card'" v-if="content.type === 'LO'"  @click="play(content)" >
                        <div class="row">
                            <div class="col-md-12 video-col">
                              <div class="video-wraper" v-if="checkValue(content.thumbnail)">
                                <video class="video-css" width="100%" height="240" :poster="makePath(content.thumbnail)">
                                    <source src="../../../static/assets/images/a.mp4" type="video/mp4">
                                    {{$t('common.errors.videoTagError')}}
                                <!-- <div class="overlay"></div> -->
                                </video>
                                 <span class="play-icon"><i class="mdi mdi-play-circle"></i></span>
                              </div>
                              <div class="video-wraper"  v-else>
                                <video class="video-css" width="100%" height="240" poster="../../../static/assets/images/defaultLO.jpg">
                                    <source src="../../../static/assets/images/a.mp4" type="video/mp4">
                                    {{$t('common.errors.videoTagError')}}
                                <!-- <div class="overlay"></div> -->
                                </video>
                                 <span class="play-icon"><i class="mdi mdi-play-circle"></i></span>
                              </div>
                            </div>
                            <div class="col-md-12 description align-middle">
                                <strong>{{content.title}}</strong>
                                <span>{{$t('common.labels.Duration')}} &nbsp;&nbsp;<span> {{(content.duration / 60).toString().split('.')[0]}} Mins {{parseInt((content.duration / 60).toFixed(1).split('.')[1]) * 6}} sec</span> </span>
                                <!-- <span>View Count <strong>{{$store.getters.getItemWatchCount(content.contentId)}}</strong> </span> -->
                                <div v-on:click="showRating(content.contentId)" v-if="instanceName !== 'MAHADEMY'">
                                  <span class="ratingText">Your rating</span>                            
                                  <span><star-rating :rating="content.rating" v-bind:increment="0.5" @rating-selected="setRating" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                                  </star-rating></span>  
                                </div>
                              </div>
                            
                            
                        </div>                        
                    </div>
                </div>                
                </div>
                <div class="watermark" v-else>
                    <span>{{$t('contentViewer.labels.noResultFoundError')}}</span>
                </div>   
              </div>
            </div>
            <div  class="col-md-8 video-gallery">
              <div class="row gallery-head">
              <div class="col-auto pr-0">                
                <b-dropdown id="language-dd" :text="getLanguageNameById(language)"  @change="setContentPathByLanguage" v-model="language">
                  <b-dropdown-item :value="index + 1" @click="setContentPathByLanguage(lang)" v-for="(lang,index) in getLanguages()" :key="index">{{lang}}</b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="col video-title">
              <h5>{{$store.getters.getcurrentPlayingContent.title}}</h5>
            </div>    
            <!-- show no of days remaining  -->
            <div  v-if=" $store.getters.getEnrolledLODataByContentIdProfileId != null &&
                         $store.getters.getEnrolledLODataByContentIdProfileId != undefined &&
                         $store.getters.getEnrolledLODataByContentIdProfileId.expiryDate != undefined && 
                         $store.getters.getEnrolledLODataByContentIdProfileId.expiryDate != null"
                  class="col-auto wallet-amt"
            >
              <span class="mdi mdi-desktop-mac view-icon" v-b-tooltip.hover :title="getRemainingDays($store.getters.getEnrolledLODataByContentIdProfileId.expiryDate)"></span>
              
               <!-- donot {{new Date()}} {{$store.getters.getEnrolledLODataByContentIdProfileId.expiryDate }} -->
                <!-- donot <span class="mdi mdi-desktop-mac view-icon" v-b-tooltip.hover :title="($store.getters.getEnrolledLODataByContentIdProfileId.allowedViewCount) - (getViewedCount === undefined ? 0 : getViewedCount) + ' '  + 'views remaining'  "></span> -->
            </div>
            <div v-else> 
              <!-- <span class="mdi mdi-desktop-mac view-icon" v-b-tooltip.hover :title="getRemainingDays($store.getters.getExpiryDateForNonPurchaseLO($store.getters.getcurrentPlayingContent))"></span> -->
            </div>  
            </div>                    
                    <div id="container-player" v-if="isPurchase != null && isPurchase" class="container-player" >
                        <!-- <media-player  :path="'/cdpcdn/' + $store.getters.getCurrentContentPath(this.lang)"></media-player> -->
                        <div class="meadia-wraper" v-if="isVideo">
                          <videoPlayer :path="getCdpCdnUrl"></videoPlayer>
                        </div>

                        <!-- HTML Component -->
                        <div class="meadia-wraper" v-if="isHTML">
                          
                          <htmlViewer :path="getCdpCdnUrl"></htmlViewer>
                        </div>

                        <!-- Image Viewer -->
                        <div class="meadia-wraper" v-if="isImage">
                          <imageViewer :path="getCdpCdnUrl"></imageViewer>
                        </div>
    
                        <!-- PDF Viewer -->
                        <div class="meadia-wraper" v-if="isPDF">
                          <pdfViewer :path="getCdpCdnUrl"></pdfViewer>
                        </div>
                         <!-- PDF Viewer -->
                        <div class="meadia-wraper" v-if="isYoutube">
                          <youtube-player :path="getCdpCdnUrl"></youtube-player>
                        </div>
    
                        <!-- SWF Player -->
                        <!-- <div v-if="isSWF" width="100%" controls style="height: calc(100vh - 80px)"> -->
                        <div class="meadia-wraper" v-if="isSWF" controls>
                          <swfPlayer :path="getCdpCdnUrl"></swfPlayer>
                        </div>

                        <!-- Audio Player -->
                        <div class="meadia-wraper" v-if="isAudio">
                          <audioPlayer :path="getCdpCdnUrl"></audioPlayer>
                        </div>
                       
                          
                        
                </div>
                 <div class="video-not-found text-center" v-else-if="showViewCountExhaustedMsg != null" >
                    <span v-if="showViewCountExhaustedMsg">
                      <h5 class="mt-3">{{$t('contentViewer.labels.viewCountExhausted')}}</h5>
                    </span>
                    <span v-else >
                      <h5 class="mt-3">{{$t('contentViewer.labels.itemNotPurchased')}}</h5>
                    </span>
                      <div v-if="cartAdd($store.getters.getcurrentPlayingContent.contentId)" class="col">
                        <button class='btn btn-green-outline'>{{$t('common.labels.ADDED')}}</button>
                      </div>
                      <div v-else class="col">
                        <button @click="addToCart($store.getters.getcurrentPlayingContent.contentId)" class='btn btn-green-outline mt-3'>{{$t('common.labels.ADD_TO_CART')}}</button>
                      </div>
                    <!-- <button  @click="addToCart($store.getters.getcurrentPlayingContent.contentId)" class='btn btn-green-outline'>{{$t('common.labels.ADD_TO_CART')}}</button> -->

                  </div>
                       <!-- {{$store.getters.getLoaderStatus}} -->
                        <!-- <b-link @click="playPrevious">Previous  </b-link>
                        <b-link @click="playNext"> &nbsp;&nbsp;  Next</b-link> -->
            </div>
            
        </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import vSelect from 'vue-select'
import htmlViewer from './contentHelper/htmlViewer'
import swfPlayer from './contentHelper/swfPlayer'
import videoPlayer from './contentHelper/videoPlayer'
import audioPlayer from './contentHelper/audioPlayer'
import imageViewer from './contentHelper/imageViewer'
import pdfViewer from './contentHelper/pdfViewer'
import youtubePlayer from './contentHelper/youtube-player'
import axios from 'axios'
import {CDP_CDN_URL, CDP_CDN_THUMBNAIL_URL, INSTANCE_NAME} from '@/components/common/constants.js'
export default {
  name: 'framesVideo',
  components: {StarRating, 'v-select': vSelect, htmlViewer, swfPlayer, videoPlayer, audioPlayer, imageViewer, pdfViewer, youtubePlayer},
  data () {
    return {
      instanceName: INSTANCE_NAME,
      contentPath: '',
      language: '1',
      selected: 'English',
      mediaPath: '',
      lang: 'en',
      media: '',
      videoHolder: '',
      swfHolder: '',
      pdfHolder: '',
      currentTime: '5',
      previousCalled: 0,
      isPurchase: null,
      showViewCountExhaustedMsg: null,
      cdpcdnurl: CDP_CDN_URL,
      searchLOString: ''
    }
  },
  mounted () {
    this.$store.dispatch('setLoaderStatus', false)
    this.$store.dispatch('setCurrentLang', this.language)
    window.scrollTo(0, 0)
    this.$Progress.start()
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'static/js/contentHelper.js'
    document.body.appendChild(script)
  },
  methods: {
    isObjectEmpty (loObj) {
      if (Object.keys(loObj).length !== 0) {
        return true
      } else {
        return false
      }
    },
    getRemainingDays (expiryDate) {
      if (expiryDate !== '') {
        var expiryDateTemp
        var oneDay = 1000 * 60 * 60 * 24
        var expiryDateList = expiryDate.substring(0, expiryDate.indexOf('T')).split('-')
        var newDate = {
          'year': expiryDateList[0],
          'month': parseInt(expiryDateList[1]) - 1,
          'day': expiryDateList[2]
        }
        expiryDateList = []
        expiryDateList = expiryDate.substring(expiryDate.indexOf('T') + 1, expiryDate.indexOf('.')).split(':')
        newDate['hour'] = expiryDateList[0]
        newDate['min'] = expiryDateList[1]
        newDate['sec'] = expiryDateList[2]
        // convert expiryDate & currentDate in mili seconds
        expiryDate = new Date(newDate['year'], newDate['month'], newDate['day'], newDate['hour'], newDate['min'], newDate['sec']).getTime()
        expiryDateTemp = new Date(newDate['year'], newDate['month'], newDate['day'], newDate['hour'], newDate['min'], newDate['sec'])
        var currentDate = new Date().getTime()
        var currentDateTemp = new Date()
        // calculate the difference in miliSeconds
        var differenceInMs = Math.abs(currentDate - expiryDate)
        // if difference  is more than 24 hr
        if (Math.round(differenceInMs / oneDay) !== 0) {
          if (Math.round(differenceInMs / oneDay) > 1) {
            return Math.round(differenceInMs / oneDay) + ' days remaining'
          } else {
            return Math.round(differenceInMs / oneDay) + ' day remaining'
          }
        } else { // if difference is less than 24 hr
          var date1Hr = expiryDateTemp.getHours()
          var date2Hr = currentDateTemp.getHours()
          var date1Min = expiryDateTemp.getMinutes()
          var date2Min = currentDateTemp.getMinutes()
          if (Math.abs(date1Hr - date2Hr) !== 0) {
            return Math.abs(date1Hr - date2Hr) + ' hr ' + Math.abs(date1Min - date2Min) + ' min remaing'
          } else {
            return Math.abs(date1Min - date2Min) + ' min remaing'
          }
        }
      }
    },
    cartAdd (itemId) {
      if (this.$store.getters.getCartData.items !== undefined && this.$store.getters.getCartData.items !== null) {
        for (var j = 0; j < this.$store.getters.getCartData.items.length; j++) {
          if (this.$store.getters.getCartData.items[j].itemId === itemId) {
            return true
          }
        }
      }
      return false
    },
    setRating: function (rating) {
      this.rating = rating
    },
    showRating (contentID) {
      this.$store.dispatch('showRating', {'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentID, 'rating': this.rating}).then(response => {
        this.$toasted.success(this.$t('common.alerts.RATING_ADDED'))
      }, error => {
        this.$toasted.error(error)
        console.log('error in adding rating', error)
      })
      /* axios.post('/r/rating/addratingdata', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentID, 'rating': this.rating })
        .then(response => {
          this.$toasted.success(this.$t('common.alerts.RATING_ADDED'))
        })
        .catch(error => {
          this.$toasted.error(error)
        }) */
    },
    play (content) {
      this.$store.dispatch('setPreviousContent', this.$store.getters.getcurrentPlayingContent).then(response => {
        if (this.$store.getters.getcurrentPlayingContent.contentId !== content.contentId) {
          this.showViewCountExhaustedMsg = false
          this.getPurchaseStatus(content.contentId).then(response => {
            this.$store.dispatch('setCurrentPlayingContent', content).then(response => {
              if (this.isPurchase) {
                this.selected = 'English'
                this.language = '1'
                /* this.$store.dispatch('updatelowatchcount', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': content.contentId}).then(response => {
                  this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
                }, error => {
                  console.log('error in updating LO watch count', error)
                }) */
                axios.post('r/contentviewer/updatelowatchcount', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': content.contentId}).then(response => {
                  this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
                }).catch(err => {
                  console.log(err)
                })
              }
            })
          })
        }
      })
    },
    getLanguageIdByName (languageId) {
      if (languageId === 'English') {
        return '1'
      } else if (languageId === 'Hindi') {
        return '2'
      } else if (languageId === 'Marathi') {
        return '3'
      }
    },
    setContentPathByLanguage (languageId) {
      if (languageId === 'English') {
        this.language = '1'
      } else if (languageId === 'Hindi') {
        this.language = '2'
      } else if (languageId === 'Marathi') {
        this.language = '3'
      }
      this.$store.dispatch('setCurrentLang', this.language)
    },
    playNext: function (event) {
      if (this.$store.getters.getCurrentContentViewerPlaylist !== null) {
        for (var i = 0; i < this.$store.getters.getCurrentContentViewerPlaylist.length; i++) {
          if (this.$store.getters.getCurrentContentViewerPlaylist[i].contentId === this.$store.getters.getcurrentPlayingContent.contentId) {
            if (this.$store.getters.getCurrentContentViewerPlaylist.length > (i + 1)) {
              this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[i + 1])
              break
            } else {
              this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[0])
              break
            }
          }
        }
      }
    },
    playPrevious: function (event) {
      if (this.$store.getters.getCurrentContentViewerPlaylist !== null) {
        for (var i = 0; i < this.$store.getters.getCurrentContentViewerPlaylist.length; i++) {
          if (this.$store.getters.getCurrentContentViewerPlaylist[i].contentId === this.$store.getters.getcurrentPlayingContent.contentId) {
            if ((i - 1) >= 0) {
              this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[i - 1])
              break
            } else {
              this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[0])
              break
            }
          }
        }
      }
    },
    getFileExtension (aggregationPath) {
      return aggregationPath != null ? aggregationPath.substr((aggregationPath.lastIndexOf('.') + 1)) : ''
    },
    getLanguages () {
      var result = []
      if (this.$store.getters.getcurrentPlayingContent.languageId !== undefined) {
        this.$store.getters.getcurrentPlayingContent.languageId.forEach(element => {
          result.push(this.getLanguageNameById(element))
        })
        return result
      }
    },
    getLanguageNameById (languageId) {
      if (languageId === '1') {
        return 'English'
      } else if (languageId === '2') {
        return 'Hindi'
      } else if (languageId === '3') {
        return 'Marathi'
      }
    },
    getContentValidityStatus (contentId) {
      /*
        check if item is in enrolled list => then call  viewItemValidityStatus
        else check if tag is not expired
      */
      if (this.$store.getters.getItemPurchasedStatus(contentId)) {
        // console.log('content purchased')
        return new Promise((resolve, reject) => {
          axios.post('r/viewItemValidityStatus', {'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentId})
          .then(response => {
            if (response.data === 'ITEM_NOT_PURCHASED_BY_USER') {
              this.isPurchase = false
            }
            if (response.data === 'VIEW_LIMIT_CROSSED') {
              this.isPurchase = false
              this.showViewCountExhaustedMsg = true
            }
            if (response.data === 'ITEM_NOT_EXPIRED') {
              this.isPurchase = true
            }
            resolve()
          }).catch(err => {
            console.log(err)
            reject(err)
          })
        })
      } else {
        // console.log('check if tag is allocated')
        return new Promise((resolve, reject) => {
          axios.post('o/getAllocatedTag', {'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentId})
          .then(res => {
            this.isPurchase = true
            resolve()
          })
          .catch(err => {
            console.log('error in getting getAllocateTag : ', err)
            reject()
          })
        })
      }
    },
    getPurchaseStatus (contentId) {
      /* this.$store.dispatch('getPurchaseStatus', {'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentId}).then(response => {
        console.log(response.data)
        if (response.data === 'ITEM_NOT_PURCHASED_BY_USER') {
          this.isPurchase = false
        }
        if (response.data === 'VIEW_LIMIT_CROSSED') {
          this.isPurchase = false
          this.showViewCountExhaustedMsg = true
        }
        if (response.data === 'ITEM_NOT_EXPIRED') {
          this.isPurchase = true
        }
      }, err => {
        console.log('error in getting item validity status : ', err)
      }) */
      return new Promise((resolve, reject) => {
        axios.post('r/viewItemValidityStatus', {'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentId}).then(response => {
          if (response.data === 'ITEM_NOT_PURCHASED_BY_USER') {
            this.isPurchase = false
          }
          if (response.data === 'VIEW_LIMIT_CROSSED') {
            this.isPurchase = false
            this.showViewCountExhaustedMsg = true
          }
          if (response.data === 'ITEM_NOT_EXPIRED') {
            this.isPurchase = true
          }
          resolve()
        }).catch(err => {
          console.log(err)
          reject(err)
        })
      })
    },
    addToCart (id) {
      this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(
          response => {
            this.$toasted.success(this.$t('common.alerts.CART_ADDED_SUCCESS'))
          },
          error => {
            console.log('error in adding item to cart', error)
          }
      )
    },
    checkValue (val) {
      if (val.length === 0) {
        return false
      } else {
        return true
      }
    },
    makePath (path) {
      return CDP_CDN_THUMBNAIL_URL + '/' + path
      // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
    }
  },
  computed: {
    getCdpCdnUrl () {
      let rx = new RegExp('www.youtube.com')
      if (rx.test(this.$store.getters.getCurrentContentPath(this.language))) {
        return this.$store.getters.getCurrentContentPath(this.language) + '?controls=0'
      }
      return this.cdpcdnurl + this.$store.getters.getCurrentContentPath(this.language)
    },
    isEnded () {
      return this.$refs.player.ended()
    },
    isImage () {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'jpg' || this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'jpeg' || this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'png') {
        this.media = 'image'
        return true
      }
      return false
    },
    isVideo () {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'mp4') {
        this.media = 'video'
        return true
      }
      return false
    },
    isYoutube () {
      let rx = new RegExp('www.youtube.com')
      return this.$store.getters.getCurrentContentPath(this.language) !== '' && rx.test(this.$store.getters.getCurrentContentPath(this.language))
    },
    isAudio () {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'mp3') {
        this.media = 'audio'
        return true
      }
      return false
    },
    isSWF () {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'swf') {
        this.media = 'swf'
        // this.$refs.frame.src = this.$store.getters.getCurrentContentPath(this.language)
        return true
      }
      return false
    },
    isHTML () {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'html') {
        this.media = 'html'
        return true
      }
      return false
    },
    isPDF () {
      if (this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'pdf') {
        this.media = 'pdf'
        return true
      }
      return false
    },
    isLO () {
      return this.getFileExtension(this.$store.getters.getCurrentContentPath(this.language)) === 'lo'
    },
    getViewedCount () {
      if (this.$store.getters.getEnrolledLODataByContentIdProfileId.watchedOn !== undefined) {
        return this.$store.getters.getEnrolledLODataByContentIdProfileId.watchedOn !== null ? this.$store.getters.getEnrolledLODataByContentIdProfileId.watchedOn.length : 0
      } else {
        return 0
      }
    }
  },
  beforeDestroy () {
    let scripts = document.getElementsByTagName('script')
    let i = scripts.length
    while (i--) {
      if (scripts[i].src.search('/static/assets/js/contentHelper.js') >= 0) {
        scripts[i].parentNode.removeChild(scripts[i])
      }
    }
    this.isPurchase = false
    this.showViewCountExhaustedMsg = false
  },
  created () {
    // this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[0])
    if (this.$store.getters.getIsplaylist) { // playList
      if (this.$store.getters.getcurrentPlaylist.lastItemViewed.itemId !== '') {
        this.getContentValidityStatus(this.$store.getters.getcurrentPlaylist.lastItemViewed.itemId).then(response => {
          this.contentPath = this.$store.getters.getContentById(this.$store.getters.getcurrentPlaylist.lastItemViewed.itemId)
          if (this.isPurchase) {
            this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getContentById(this.$store.getters.getcurrentPlaylist.lastItemViewed.itemId)).then(response => {
              // axios.post('r/contentviewer/updatelowatchcount', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlaylist.lastItemViewed.itemId}).then(response => {
              //   this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
              // }).catch(err => {
              //   console.log(err)
              // })
            })
          }
        })
      } else {
        this.getContentValidityStatus(this.$store.getters.getCurrentContentViewerPlaylist[0].contentId).then(response => {
          this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[0])
          if (this.isPurchase) {
            this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[0]).then(response => {
              this.contentPath = this.$store.getters.getContentById(this.$store.getters.getCurrentContentViewerPlaylist[0].contentId)
              // axios.post('r/contentviewer/updatelowatchcount', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getCurrentContentViewerPlaylist[0].contentId}).then(response => {
              //   this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
              // }).catch(err => {
              //   console.log(err)
              // })
            })
          }
        })
      }
    } else {
      this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[0])
      // this.getContentValidityStatus(this.$store.getters.getCurrentContentViewerPlaylist[0].contentId)
      this.getContentValidityStatus(this.$store.getters.getCurrentContentViewerPlaylist[0].contentId).then(response => {
        // console.log('check if purchase')
        // this.isPurchase = true
        if (this.isPurchase) {
          this.$store.dispatch('setCurrentPlayingContent', this.$store.getters.getCurrentContentViewerPlaylist[0]).then(response => {
            this.contentPath = this.$store.getters.getCurrentContentViewerPlaylist[0]
            // axios.post('r/contentviewer/updatelowatchcount', {'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getCurrentContentViewerPlaylist[0].contentId}).then(response => {
            //   this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            // }).catch(err => {
            //   console.log(err)
            // })
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';

.frames-video{
    padding-top:15px;
    padding-bottom:20px;
    .clear{
      display:none;
    }
    .ratingText{
      /* padding-left:15px; */
    }
      .v-select {
    display: inline-block;
    font-size: 14px;
    .input[type='search'] {
      font-size: 14px;
    }
    .dropdown-toggle {
      z-index: 3;
      border-left: 0px;
      border-right: 0px;
      border-top: 0px;
      padding-left: 0px;
      border-radius: 0px;
      font-family: $opensans;
      border-color: #e1e1e1;
      .clear {
        line-height: 20px;
      }
      
    }
    .dropdown-menu {
      z-index: 3;
      // box-shadow: none;
      font-family: $opensans;
      border-radius: 5px;
      font-size: 14px;
      border: none;
      color:#333;
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
        li{ &:hover{color: #fff;}}
    }
    .selected-tag {
      color: #495057;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.25px;
    }
  }
    .input-find{   
      order: 2;
        /* margin-top:15px; */
        input{outline: none;  font-size: 14px; font-weight: 600; -webkit-box-shadow: none; box-shadow: none;  border: none;  background-color: #fff; padding-left: 0px; padding: 12px 40px 12px 15px; border-radius: 3px; transition: 0.3s ease all;box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.18);
        +.input-icon{position: absolute; right: 15px; top:8px; z-index: 10;color: #495057; opacity: 0.7; transition: .3s ease all;}
          &:hover,&:focus{    box-shadow: 10px 10px 17px rgba(0, 0, 0, 0.2);
          +.input-icon{
            opacity: 1;
          }
          }
        }
       /*  button{background-color: inherit; padding-left:0px; font-size:20px;color:#636C72;} */
        .search-box{position: relative; margin:0 0px 15px 0; }
    }
    .wallet-amt{ padding-bottom:0px; font-family: $opensans;line-height:31px;margin-left: auto; margin-right: 10px;
        a{font-size:32px; font-weight:600; color:#d3d3d3; &:hover{color:#444;}}
        i{padding-left:15px;}
        .view-icon {font-size: 20px;}
    }
    .frame-holder {height:auto;}
    .myscrollbar{
        max-height: 520px;
        min-height: 520px;
    }

  .vue-scrollbar__scrollbar-vertical .scrollbar{
        width:0px;
    }
    .vue-scrollbar__wrapper {background-color:#f1f1f1;}
    .vue-scrollbar__scrollbar-vertical, .vue-scrollbar__scrollbar-horizontal{opacity:0;}
    .playing-video{
        object-fit:cover;
        border-radius: 3px; 
        min-height: 520px;
    }
    %card{
        border-radius: 3px;
        border-bottom:1px solid #eee;
        border: none;
        transition: box-shadow .25s;
        margin-bottom:5px;
        padding:15px;
        hr{margin-top:10px;}
        .row {
            .video-col {
                .video-css{ 
                    width:100%; 
                    height:100%; 
                    border-radius: 3px; 
                    object-fit:cover;   
                }
                .overlay{ 
                    width:100%; height:100%;
                    top:0px;   
                    border-radius:3px;
                    position: absolute;
                    z-index:2;
                    background: linear-gradient(to right, rgba(92, 184, 234,0.9) 0%,rgba(110, 99, 197, 0.9) 100%);
                }
                .video-wraper{
                  position: relative;
                }
            }
        }
        .description{
            color:#555;
            strong{display:block;color:#333;}
            span{font-size:12px;font-weight:600; color:#999; span{ color:#333;} }
            div{ font-size:12px; padding-bottom:10px; }
            div.vue-star-rating{padding:0px;}
          }
        .play-icon{
                position: absolute;
                top:50%;
                left:50%;
                z-index:2;
                color:#fff;font-size:50px;opacity:0.5;
                transform: translate(-50%, -50%);
                transition:all 0.1s ease;
        }
        &:hover {
          .play-icon{opacity:1;}
                cursor: pointer;
                opacity:1;
                transition: box-shadow .45s;
                // z-index:2;
        }
    }
    .cards{
      padding: 0px 10px 10px 10px;
    }
     
    .card{ 
        @extend %card; 
        background-color: #f1f1f1;
        // box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1);
        .play-icon { .fa{ color: rgba(255, 255, 255, .7); }}
        transition: 300ms ease;
        &:hover{background:#fff; box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);}
    }
    .card-active{
        @extend %card; 
        background-color: #fff;
         box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);
       .play-icon { .fa{ color: rgba(255, 255, 255, .9); }}
       &:hover{background:#fff;}
    }
}
.container-player {
    padding: 0 0 0 0; // padding-bottom: 0;
    transition: 200ms all;
    border-radius:10px;
    height: calc( 100% - 58px );
    // background: #e1e1e1; 
    .content-help-wrapper {
      height: calc(100vh - 100px);
      .player {
        height: calc(100vh - 100px);
      }
    }
  }

.media-container{
  // padding-right:15px; 
}
#pdfHolder{
  padding:0 5px;  
  width:100%; 
  height: calc(100vh - 240px)
}
#htmlHolder,#imgHolder{
  width:100%; 
  height: calc(100vh - 300px)
}
#language-dd {
  button {background: transparent; color: #333; border: none;font-size: 14px; font-weight: 600;
    &:hover, &:focus, &:active {box-shadow: none;}
  }
  .dropdown-menu {
    a {font-size: 13px;
    &:hover {background: #f2f2f2;}
    }
  }
}
.watermark{
  font-size: 25px;
  color: #bbb;
}
.video-gallery{
  background: #fff;
  margin-bottom:30px;
  padding: 0 15px;
  border-radius:3px; 
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.18);
  .gallery-head{
    border-bottom: 1px solid #eee;
    padding: 13px 0 10px 0;
  }
  .video-title{
    flex-basis: unset;
    order: 1;
    h5{
    font-size: 16px;
    margin-bottom: 0;
    line-height: 33px;
    }
  }
  .select-language{
    padding: 0 0 0 0;
  }
}
.video-not-found{
  padding: 50px 0;
}
.meadia-wraper{
  height: 100%;
}
@media screen and (min-width:767px) {
    .frames-video {
      padding-top: 30px;
      padding-bottom: 60px;
  
    .input-find{
      order: 0;
      .search-box{
            margin: 0 25px 15px 0;
      }
    } 
    .cards {
      padding: 0px 25px 10px 0px;
    }
    .frame-holder {height: 510px;}
    .card{        
            &:hover{background:#fff; box-shadow: 10px 10px 17px rgba(0, 0, 0, 0.2);}
      }
  }
  .container-player {
      padding: 20px 10px 0 10px;
    }
  .video-gallery {
  .video-title{
      flex-basis: 0;
      order: 0
    }
    .select-language{
      padding: 0 0 0 15px;
    }
  }
}

</style>




// WEBPACK FOOTER //
// src/components/contentViewer/framesVideo.vue?3561cb2e